import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/views/Home'
import Board from '@/views/Board'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/board/:id',
    name: 'board',
    component: Board,
    props: true,
  }
]

const router = new VueRouter({
  routes
})

export default router
